/* Languange EN */

var enFooter = {
  "footer.desc"         : "The only creator marketing platform you’ll need. We create a platform that streamlines the campaign process for creators, brands, and agencies to collaborate.",
};
  
export default enFooter;